import React, { Component } from 'react'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'
import FinanceResults from '../../../../../../../../../components/FinanceResults'

@hocBlock(config.modules.report.key)
export default class Fstmt extends Component {
    render() {
        return <FinanceResults {...this.props} />
    }
}
